var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.75C2.44922 0.75 0 3.2207 0 6.25C0 9.30078 2.44922 11.75 5.5 11.75C8.5293 11.75 11 9.30078 11 6.25C11 3.2207 8.5293 0.75 5.5 0.75ZM7.77734 8.16211C7.94922 8.37695 7.92773 8.69922 7.71289 8.89258C7.62695 8.97852 7.49805 9 7.39062 9C7.24023 9 7.08984 8.95703 6.98242 8.82812L5.5 7.06641L3.99609 8.82812C3.88867 8.95703 3.73828 9 3.58789 9C3.48047 9 3.37305 8.97852 3.26562 8.89258C3.05078 8.69922 3.0293 8.37695 3.20117 8.16211L4.8125 6.25L3.20117 4.35938C3.0293 4.14453 3.05078 3.82227 3.26562 3.62891C3.48047 3.45703 3.80273 3.47852 3.99609 3.69336L5.5 5.45508L6.98242 3.69336C7.17578 3.47852 7.49805 3.45703 7.71289 3.62891C7.92773 3.82227 7.94922 4.14453 7.77734 4.35938L6.16602 6.25L7.77734 8.16211Z",
    fill: "#E85C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.ca5275107dc4cbe963cbc361b4cd8648.svg";
export { ForwardRef as ReactComponent };